export default "__VITE_ASSET__d288f2a1__"